function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOobm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.55 24.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 4.65,
    y: 11.69,
    width: 2.47,
    height: 3.7,
    rx: 1.18,
    ry: 1.18,
    style: {
      fill: "#f40006",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.18,
    y: 11.69,
    width: 2.47,
    height: 3.7,
    rx: 1,
    ry: 1,
    style: {
      fill: "#64df00",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.42,
    y: 11.69,
    width: 2.46,
    height: 3.7,
    rx: 1,
    ry: 1,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.35,8.24h-2.35V1.18c0-.65-.53-1.18-1.18-1.18s-1.18.53-1.18,1.18v7.06H5.88V1.18c0-.65-.53-1.18-1.18-1.18s-1.18.53-1.18,1.18v7.06H1.18c-.65,0-1.18.53-1.18,1.18v8.24c0,.65.53,1.18,1.18,1.18h21.18c.65,0,1.18-.53,1.18-1.18v-8.24c0-.65-.53-1.18-1.18-1.18Zm-15.3,5.88c0,.65-.53,1.18-1.18,1.18s-1.18-.53-1.18-1.18v-1.18c0-.65.53-1.18,1.18-1.18s1.18.53,1.18,1.18v1.18Zm3.53,0c0,.65-.53,1.18-1.18,1.18s-1.18-.53-1.18-1.18v-1.18c0-.65.53-1.18,1.18-1.18s1.18.53,1.18,1.18v1.18Zm8.24,0c0,.65-.53,1.18-1.18,1.18s-1.18-.53-1.18-1.18v-1.18c0-.65.53-1.18,1.18-1.18s1.18.53,1.18,1.18v1.18Z",
    style: {
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.82,
    y: 10.32,
    width: 2.35,
    height: 3.53,
    rx: 1,
    ry: 1,
    transform: "translate(7.91 32.09) rotate(-90)",
    style: {
      fill: "#64df00",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.53,13.31c-2.02.91-3.32,1.34-5.52,1.58,0,1.91.13,3.29.62,4.55.4,1.03,1,1.97,1.76,2.77,1.22,1.3,2.57,1.98,3.14,2.15.57-.16,1.91-.85,3.14-2.15.76-.8,1.36-1.74,1.76-2.77.49-1.26.62-2.63.62-4.55-2.2-.24-3.5-.66-5.52-1.58Z",
    style: {
      fill: "#ffd435",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOobm);
export default __webpack_public_path__ + "static/media/OOBM.545f9a819a82a121d726ecc6598ac375.svg";
export { ForwardRef as ReactComponent };